const SPOTLIGHT_GCLID_KEY = "spotlight_gclid";
const THIRTY_DAYS_IN_MS = 1000 * 60 * 60 * 24 * 30;

type SetWithExpiryParamsType = {
  key: string;
  value: string;
  expiry: number;
};

function setWithExpiry({ key, value, expiry }: SetWithExpiryParamsType) {
  const now = new Date().getTime();
  const itemStr = localStorage.getItem(key);

  if (itemStr) {
    const item = JSON.parse(itemStr);

    if (now < item.expiry) {
      return;
    }

    localStorage.removeItem(key);
  }

  const item = {
    value,
    expiry: now + expiry,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);

  if (new Date().getTime() > item.expiry) {
    localStorage.removeItem(key);

    return null;
  }

  return item.value;
}

function getGclidFromUrlOrLocalStorage(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const gclid = urlParams.get("gclid");

  if (gclid) {
    setWithExpiry({
      key: SPOTLIGHT_GCLID_KEY,
      value: gclid,
      expiry: THIRTY_DAYS_IN_MS,
    });
  }

  return getWithExpiry(SPOTLIGHT_GCLID_KEY);
}

export default function getGclid(): void {
  const gclid = getGclidFromUrlOrLocalStorage();

  if (gclid) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ gclid });
  }
}
